var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button-play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeline-preview-01",
    transform: "translate(-1344.000000, -120.000000)",
    fill: "#95C11F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1324.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-play",
    transform: "translate(20.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C23.2842712,30 30,23.2842712 30,15 C30,6.71572875 23.2842712,0 15,0 C6.71572875,0 0,6.71572875 0,15 C0.00895605952,23.2805587 6.71944131,29.9910439 15,30 Z M20.28125,16.2512645 L12.675,20.4289371 C12.4697573,20.5459009 12.2424429,20.6084541 12.01125,20.6116587 C11.7960053,20.613351 11.5846404,20.5486342 11.40125,20.4248171 C11.0226519,20.1480416 10.8046642,19.6727031 10.8275,19.1737126 L10.8275,11.0628204 C10.7885512,10.5604955 11.0099783,10.0767786 11.400252,9.81161974 C11.7905257,9.54646083 12.283346,9.54490524 12.675,9.80759599 L20.28125,13.9866419 C20.7060902,14.1746742 20.9925715,14.6170356 21.015,15.1196399 C20.9920957,15.621737 20.7056944,16.0634389 20.28125,16.2512645 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlay);
export default __webpack_public_path__ + "static/media/button-play.718b042f0c64162bdb41abed6ae8a919.svg";
export { ForwardRef as ReactComponent };